export default "<p>\n  content-loader works!\n</p>\n"